import React from 'react';
export function useVideoAPI(compRef, hasVideo, onStop) {
    const videoRef = React.useRef(null);
    const videoAPI = React.useRef(null);
    if (hasVideo) {
        if (!videoAPI.current) {
            videoAPI.current = {
                play: () => { var _a; return (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.play(); },
                load: () => { var _a; return (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.load(); },
                pause: () => { var _a; return (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.pause(); },
                stop: () => {
                    if (videoRef.current) {
                        videoRef.current.pause();
                        videoRef.current.currentTime = 0;
                        if (onStop) {
                            onStop(videoRef.current);
                        }
                    }
                },
            };
        }
    }
    else {
        // no video remove video API
        videoAPI.current = null;
    }
    React.useImperativeHandle(compRef, () => {
        return videoAPI.current || { load() { }, stop() { } };
    });
    return videoRef;
}
//# sourceMappingURL=useVideoAPI.js.map